const pluralRules = new Intl.PluralRules('en-US');

export default function getAmountLabel(count: number, unit: string) {
  const formattedCount = count.toLocaleString('en-US');
  const form = pluralRules.select(count);
  const formattedUnit = form === 'one' ? unit : `${unit}s`;
  return `${formattedCount} ${formattedUnit}`;
}
